import { gql } from "@apollo/client";

export const CREATE_SUPPORT_TICKET = gql`
  mutation CreateSupportTicket($createSupportTicketData: CreateSupportTicketRequest!) {
    createSupportTicket(createSupportTicketData: $createSupportTicketData) {
      ticketId
      status
    }
  }
`;

export const GET_SUPPORT_TICKET_MAPPINGS = gql`
  query GetSupportTicketMappings {
    getSupportTicketMappings {
      internalKey
      label
      fieldType
      options {
        value
        name
      }
    }
  }
`;
